<script>
export default {
  name: 'Corporate',
  props: {
    color: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    onGaClick() {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004554&token=15eccb6f-b9c0-4927-b0d7-445f0ca763b8')
    },
    onBaClick() {
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>

<template>
  <div class="corporate" :class="{'corporate-between': position === 'between'}" :style="{color: color || ''}">
    <div class="cor-group">
      <p class="compa">主办：中共洪雅县委组织部</p>
      <p class="compa">技术支持：成都集思创科技有限公司</p>
    </div>
    <div class="cor-group">
      <p class="beian cor-hover" :style="{color: color || ''}" @click="onBaClick">备案号: 蜀ICP备18002263号-1</p>
      <div class="emblem">
        <el-image class="emblem-img" :src="require('imgs/beian.png')" alt="" />
        <p class="emblem-text cor-hover" @click="onGaClick">
          公安备案号: 51019002004554号
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.corporate {
  color: #fff;
  text-shadow: 0 0 5px #000;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 20px;
  .cor-group {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 20px;
  }
  .beian {
    cursor: pointer;
    color: #fff;
    text-shadow: 0 0 5px #000;
    padding-top: 10px;
  }
  .compa {
    padding-top: 8px;
  }
  .cor-hover {
    &:hover {
      color: #fff;
      text-shadow: 0 0 5px #000;
      text-decoration: underline;
    }
  }
  .emblem {
    display: flex;
    align-items: center;
    margin-top: 8px;
    cursor: pointer;
    .emblem-img {
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
  }
}
.corporate-between {
  justify-content: space-between;
}
</style>
